import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import { getCompany, listUserCompaniesCustom } from "../../graphql";
import { PURGE } from "redux-persist";
import { showErrorSnackbar } from "../../components/snackBar/snakbar";

export const fetchCompany = createAsyncThunk(
  "company/fetchCompany",
  async () => {
    const response = await API.graphql(graphqlOperation(getCompany));
    if (response?.data?.getCompany) return response?.data?.getCompany;
  }
);

export const fetchCompanyList = createAsyncThunk(
  "company/fetchList",
  async () => {
    try {
      const response = await API.graphql(graphqlOperation(listUserCompaniesCustom));
      let arr = [];
      if (response?.data?.listUserCompanies?.length > 0) {
        response?.data?.listUserCompanies?.map((item) => {
          let obj = {
            CompanyID: item?.companyid,
            CompanyShort: item?.companyshort,
            companydeletiontime: item?.companydeletiontime,
            RelatedFinancialYearData: item?.relatedfinancialyeardata,
            isExpanded: false,
          };
          arr.push(obj);
        });
      }
      return arr;
    } catch (error) {
      console.log(error);
    }
  }
);
const INITIAL_STATE = {
  companyName: "",
  companyDetails: null,
  companyList: [],
  render: true,
  Loaded: false,
  loading: false,
};
const companySlice = createSlice({
  name: "company",
  initialState: INITIAL_STATE,
  reducers: {
    setCompanyName(state, action) {
      state.companyName = action.payload;
    },

    setCompanyDetails: (state, action) => {
      state.companyDetails = action.payload;
    },
    setCompanyList: (state, action) => {
      state.companyList = action.payload;
    },
    setRemoveCompanyRelatedFY: (state, action) => {
      const { companyid, fyid } = action.payload
      const index = state.companyList.findIndex(
        (obj) => obj.CompanyID === companyid
      );
      if (index !== -1) {
        const fyIndex = state.companyList[index].RelatedFinancialYearData.findIndex(
          (obj) => obj.financialyearid === fyid
        );
        if (fyIndex !== -1) {
          state.companyList[index].RelatedFinancialYearData.splice(fyIndex, 1);
        }
      }
    },
    setDeleteCompany: (state, action) => {
      const index = state.companyList.findIndex(
        (obj) => obj.CompanyID === action.payload
      );
      if (index !== -1) {
        state.companyList.splice(index, 1);
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCompany.pending, (state) => {
        state.Loaded = false;
      })
      .addCase(fetchCompany.fulfilled, (state, action) => {
        if (action?.payload?.[0]?.companyname) {
          return {
            ...state,
            companyDetails: action.payload[0],
            Loaded: true,
            companyName: action?.payload[0]?.companyname,
          };
        } else {
          state.Loaded = true;
        }
      })
      .addCase(fetchCompany.rejected, (state) => {
        state.Loaded = false;
        console.log("Error fetching company data");
        showErrorSnackbar("Network Error !");
      })
      .addCase(fetchCompanyList.fulfilled, (state, action) => {
        state.companyList = action.payload;
        state.loading = false;
      })
      .addCase(fetchCompanyList.pending, (state, action) => {
        state.loading = true;
        state.render = false;
      })
      .addCase(fetchCompanyList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(PURGE, () => INITIAL_STATE);
  },
});

export const {
  setCompanyName,
  setCompanyDetails,
  setCompanyList,
  setDeleteCompany,
  setRemoveCompanyRelatedFY,
} = companySlice.actions;
export default companySlice.reducer;
